<ng-container [ngSwitch]="routeData?.role">

  <flexi-onboarding-list *ngSwitchCase="'list'"></flexi-onboarding-list>

  <flexi-onboarding-wizard
    *ngSwitchCase="'csm'"
    [aggregate]="routeData.aggregate!">
  </flexi-onboarding-wizard>

  <flexi-onboarding-final-view
    *ngSwitchCase="'customer'"
    [meeting]="routeData.finalView?.meeting || null"
    [actions]="routeData.finalView?.actions || []"
    [steps]="routeData.finalView?.steps || []"
    [isCompleted]="routeData.isCompleted">
  </flexi-onboarding-final-view>

  <div *ngSwitchCase="'locked'" class="fonb-shell">
    <div class="fonb-banner fonb-banner--warning">
      <i class="pi pi-lock"></i>
      <div>{{ 'FLEXI_ONBOARDING.LOCKED_NO_ONBOARDING' | translate }}</div>
    </div>
  </div>

</ng-container>
